<template>
     <van-swipe :autoplay="3000" :height="swipeHeight"  indicator-color="#fff"  class="top_swipe">
       <van-swipe-item v-for="(image, index) in images" :key="index">
          <common-link :item='image' :page="swiper"></common-link>
       </van-swipe-item>
    </van-swipe>
</template>
<script>
import commonLink from './commonLink'
export default {
    data() {
      return {
        swipeHeight:144,
        images:[],
        swiper:'swiper'

      }
    },
    props: ['banner'],
    components:{
      commonLink
    },
    watch:{
      banner:{
        handler(newName, oldName) {
          this.images=newName
        },
      deep: true,
      immediate: true
      }
    },
    mounted(){
    }
}
</script>
<style  scoped lang="scss">
.top_swipe{
  margin-bottom: 1rem;
  border-radius: 0.5rem;

}
</style>




// WEBPACK FOOTER //
// src/components/swipe.vue